export default __webpack_public_path__ + "static/media/top.3e90618b.jpeg";